import { Inject, Injectable } from '@angular/core'
import { ISeedElement, MapColorGeneratorService } from './map-color-generator.service'
import { DepartmentMapFilterService } from '../../../domain/general-map/components/general-map/services/department-map-filter.service'
import { IFilterDefTypeEnum } from '../../../shared/open-layers/layer-filter.interface'
import { ILayerConfig, LayerConfigLayerTypeEnum } from '../../../shared/open-layers/layer-config.interface'
import { LpisUserDetailDto } from '../../../api/backend'
import { MapInfoBoxTypeEnum } from '../info-box/map-info-box-type.enum'
import { AuthContextStorageService } from '../../../core/auth/auth-context-storage.service'

@Injectable({
    providedIn: 'root',
})
export class MapLpisLayerService {

    constructor(
        @Inject(DepartmentMapFilterService) protected departmentMapFilterService: DepartmentMapFilterService,
        @Inject(MapColorGeneratorService) protected mapColorGeneratorService: MapColorGeneratorService,
        @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
    ) {
    }

    public generateMapLpisLayer(layerColor: ISeedElement, id: number): ILayerConfig {
        const hexColor = this.mapColorGeneratorService.getHexColor(layerColor.mapColor)
        const projectLayerPrefix = this.getProjectLayerPrefix(this.authContextStorageService.getProjectKey())

        return {
            id: 'lpis_user_' + id,
            layer: {
                type: LayerConfigLayerTypeEnum.wms,
                url: this.getWmsProjectLayersUrlWithoutCache(),
                wms: {
                    layers: projectLayerPrefix + 'lpis',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 360
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdIsLike({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'id_uz',
                    literal: id
                }),
                sldBody: {
                    name: projectLayerPrefix + 'lpis',
                    rules: [
                        {
                            name: 'lpis_user_' + id,
                            polygonSymbolizer: {
                                fill: {
                                    svgParameter: {
                                        'fill': hexColor,
                                        'fill-opacity': layerColor.mapOpacity
                                    }
                                },
                                stroke: {
                                    svgParameter: {
                                        'stroke': hexColor,
                                        'stroke-width': 1
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        }
    }

    public getLpisLayerConfig(lpisId: number, layerColor: ISeedElement, lpisUserInfo: LpisUserDetailDto): any {
        return {
            acreage: lpisUserInfo.acreage,
            color: layerColor,
            id: 'lpis_user_' + lpisId,
            infoboxTemplate: 'lpis',
            infoboxType: MapInfoBoxTypeEnum.lpis,
            infoboxTemplatePriority: -1,
            lpisId: lpisId,
            styleAttribute: this.mapColorGeneratorService.getMapLayerIconStyle(layerColor.fill, layerColor.stroke),
            title: lpisUserInfo.userName,
            type: 'wms',
            userIdent: lpisUserInfo.ico ? 'IČ ' + lpisUserInfo.ico : 'RČ ' + lpisUserInfo.rodneCislo,
            visible: false
        }
    }

    public getLpisUserConfigGroup(config: any): any {
        return config?.layers?.find(layerGroup => layerGroup.id === 'lpis_user')
    }

    public setLpisUserConfigGroup(config: any, updatedLayerGroup): any {
        const index = config?.layers?.findIndex(layerGroup => layerGroup.id === updatedLayerGroup.id)
        if (index > -1) {
            config.layers[index] = updatedLayerGroup
        }
    }

    private getProjectLayerPrefix(projectKey: string): string {
        return 'assets:assets_' + projectKey + '_'
    }

    private getWmsProjectLayersUrlWithoutCache(): string {
        // @ts-ignore
        return CA_CONFIG.BACKEND_OPTIONS.geoserverProjectUrl + '/wms'
    }
}